import { theme as antdTheme } from 'antd';

export const theme = {
  ...antdTheme.defaultConfig,
  token: {
    ...antdTheme.defaultConfig.token,
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    borderRadius: 6,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};
